// extracted by mini-css-extract-plugin
module.exports = {"SearchBar":"SearchBar_SearchBar__MjXTt"};